// extracted by mini-css-extract-plugin
module.exports = {"summaryPoliciesWrapper":"booking_summary_summaryPoliciesWrapper__6MB-i"};